import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

function RegisterNewDevice(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
        <path d="M16.0001 31.7092C7.34556 31.7092 0.291016 24.6547 0.291016 16.0001C0.291016 7.34556 7.34556 0.291016 16.0001 0.291016C24.6547 0.291016 31.7092 7.34556 31.7092 16.0001C31.7092 24.6547 24.6547 31.7092 16.0001 31.7092ZM16.0001 1.01829C7.74556 1.01829 1.01829 7.74556 1.01829 16.0001C1.01829 24.2547 7.74556 30.9819 16.0001 30.9819C24.2547 30.9819 30.9819 24.2547 30.9819 16.0001C30.9819 7.74556 24.2547 1.01829 16.0001 1.01829ZM19.8001 8.87283V9.7092H13.2547V8.87283H19.8001ZM19.8001 22.8001H13.2547V23.5938H19.8001V22.8001ZM22.8183 19.7092V7.09102C22.8183 6.40011 22.2728 5.81829 21.6183 5.81829H11.291C10.6365 5.81829 10.091 6.40011 10.091 7.09102V24.9092C10.091 25.6001 10.6365 26.1819 11.291 26.1819H21.6183C22.2001 26.1819 22.7092 25.7456 22.8183 25.1637V19.7092H22.091V24.9092C22.091 25.2001 21.8728 25.4546 21.6183 25.4546H11.291C11.0365 25.4546 10.8183 25.2001 10.8183 24.9092V7.09102C10.8183 6.80011 11.0365 6.54556 11.291 6.54556H21.6183C21.8728 6.54556 22.091 6.80011 22.091 7.09102V19.7092H22.8183Z" fill={color}/>
    </svg>
  );
}

RegisterNewDevice.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

RegisterNewDevice.defaultProps = {
  height: 45,
  width: 45,
};

export default pure(RegisterNewDevice);
